import { useState } from "react";
import { VideoOff } from "lucide-react";

const ID_RE = /^[A-Za-z0-9_-]{20,80}$/;

export function GoogleDriveVideoPlayer({ fileId, title }) {
  const [loaded, setLoaded] = useState(false);
  const valid = ID_RE.test(fileId || "");
  return (
    <div className="relative w-full aspect-video overflow-hidden rounded-2xl bg-[#13283A]" data-testid="drive-video-player">
      {!valid ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 p-6 text-center text-white/80" data-testid="drive-video-unavailable">
          <VideoOff className="h-8 w-8" />
          <p className="text-sm">La vidéo n’est pas disponible pour le moment. Tu peux quand même faire ton exercice ci-dessous.</p>
        </div>
      ) : (
        <>
          {!loaded && (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-white/80" data-testid="drive-video-loading">
              <span className="h-9 w-9 rounded-full border-4 border-white/20 border-t-[#13B698] animate-spin" />
              <span className="text-sm">Chargement de la vidéo…</span>
            </div>
          )}
          <iframe
            src={`https://drive.google.com/file/d/${fileId}/preview`}
            title={title}
            loading="lazy"
            allow="fullscreen; encrypted-media"
            allowFullScreen
            onLoad={() => setLoaded(true)}
            className={`absolute inset-0 h-full w-full border-0 transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
            data-testid="drive-video-iframe"
          />
        </>
      )}
      {valid && <a href={`https://drive.google.com/file/d/${fileId}/view`} target="_blank" rel="noreferrer" className="sr-only focus:not-sr-only focus:absolute focus:bottom-2 focus:left-2 focus:bg-white focus:text-[#13283A] focus:px-3 focus:py-1 focus:rounded-lg text-xs">Ouvrir la vidéo dans Google Drive si elle ne s’affiche pas</a>}
    </div>
  );
}
